module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1400.6f85f78d.svg";